// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__C7wsP","primary":"Tag_primary__GkGeE","green":"Tag_green__Lfnnw","red":"Tag_red__sL8VY","grey":"Tag_grey__hri6R","yellow":"Tag_yellow__JcjSE"};